const init = () => {
    $('#toggle-menu').change(() => {
        $('.toggle-mobile-nav, #main-menu__container').toggleClass('active');
    });

    $(document).on(
        'click',
        '#main-menu__container.active .menu-item-has-children > a, #main-menu__container.active .menu-item-has-children > .no-link',
        (e) => {
            e.preventDefault();
            $(e.currentTarget).toggleClass('active');
            $(e.currentTarget).parent('li').toggleClass('open');
            $(e.currentTarget).next('ul').slideToggle();
        }
    );
};

export { init };
